__turbopack_context__.v({
  "disabled": "input-module__Ql8Foa__disabled",
  "hasFocus": "input-module__Ql8Foa__hasFocus",
  "input": "input-module__Ql8Foa__input",
});
